// Generates a base-36 timestamp token when the form mounts.
// Used to verify a minimum elapsed time before submission.
export const createFormToken = () => Date.now().toString(36);

// Returns true only if at least `minMs` ms have elapsed since the token was created.
export const validateFormTime = (token, minMs = 4000) => {
  try {
    const loadTime = parseInt(token, 36);
    return !isNaN(loadTime) && Date.now() - loadTime >= minMs;
  } catch {
    return false;
  }
};

// Detects machine-generated random strings: no spaces, mixed case, high unique-char ratio.
// Catches patterns like "wPDBmgKeETPTZRvSoiZumP" while leaving real words/sentences untouched.
export const isRandomString = (text) => {
  if (!text) return false;
  const str = text.trim();

  // Only inspect single-word strings longer than 15 chars
  if (str.length <= 15 || /\s/.test(str)) return false;

  // Skip URLs
  if (str.includes('://') || str.startsWith('www.')) return false;

  const upper = (str.match(/[A-Z]/g) || []).length;
  const lower = (str.match(/[a-z]/g) || []).length;
  const alpha = upper + lower;
  if (alpha === 0) return false;

  const upperRatio = upper / alpha;
  // Mixed case (20–80 % uppercase) is the bot signature; all-upper or all-lower is human
  if (upperRatio <= 0.20 || upperRatio >= 0.80) return false;

  // High unique-char ratio indicates random generation rather than a real word
  const uniqueRatio = new Set(str.toLowerCase()).size / str.length;
  return uniqueRatio > 0.55;
};

// For fields where a meaningful description is expected (message, projectDetails),
// any text longer than 20 chars must contain at least one space.
export const requiresWordStructure = (text, maxSingleWordLength = 20) => {
  if (!text) return true;
  const str = text.trim();
  if (str.length <= maxSingleWordLength) return true;
  if (str.includes('://') || str.startsWith('www.')) return true;
  return /\s/.test(str);
};
